import { jsPDFOptions } from 'jspdf';
import { UserOptions } from 'jspdf-autotable';
import { Typography, Button, renderIcon } from '@ecdlink/ui';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

import { useDialog } from '@ecdlink/core';
import { DialogPosition } from '@ecdlink/ui';
import OnlineOnlyModal from '@/modals/offline-sync/online-only-modal';
import { useGenerateAttendancePdf } from '@/hooks/useGenerateAttendancePdf';

export interface GeneratePdfReportButtonProps {
  isLoading?: boolean;
  tableFootStyles: UserOptions['footStyles'];
  title: string;
  outputName: string;
  tableFooter?: any[];
  tableData?: any[];
  content?: any;
  component?: string;
  tableHeadStyles?: UserOptions['headStyles'];
  tableBottomContent?: any;
  tableStyles: UserOptions['styles'];
  pageOriantations?: jsPDFOptions['orientation'];
  signature: string;
  downloadDate: string;
  numberOfChildren: number;
  onClick?: () => void;
  tableHeaders?: any[];
  logo?: string;
  classHeaders: any[];
}

const GeneratePdfReportButton = ({
  isLoading,
  title,
  tableFooter,
  tableData,
  content,
  tableBottomContent,
  outputName,
  tableHeadStyles,
  tableStyles,
  tableFootStyles,
  pageOriantations,
  component,
  signature,
  downloadDate,
  numberOfChildren,
  onClick,
  tableHeaders,
  logo,
  classHeaders,
}: GeneratePdfReportButtonProps) => {
  const { isOnline } = useOnlineStatus();
  const { generateReport } = useGenerateAttendancePdf();

  const dialog = useDialog();

  const showOnlineOnly = () => {
    dialog({
      color: 'bg-white',
      position: DialogPosition.Middle,
      render: (onSubmit) => {
        return <OnlineOnlyModal onSubmit={onSubmit}></OnlineOnlyModal>;
      },
    });
  };

  return (
    <Button
      isLoading={isLoading}
      disabled={isLoading}
      type="filled"
      color="quatenary"
      className={'w-full'}
      onClick={
        !isOnline
          ? showOnlineOnly
          : () => {
              if (!!onClick) {
                onClick();
              }
              generateReport(
                tableData ?? [],
                signature,
                downloadDate,
                tableHeadStyles,
                content,
                tableBottomContent,
                tableStyles,
                tableFootStyles,
                pageOriantations,
                tableHeaders,
                outputName,
                logo,
                classHeaders
              );
            }
      }
    >
      {renderIcon('DownloadIcon', 'h-5 w-5 text-white')}
      <Typography
        type="h6"
        color="white"
        text={title}
        className="ml-2"
      ></Typography>
    </Button>
  );
};

export default GeneratePdfReportButton;
